import { Submission, SubmissionFile, DatasetValidationResult } from "../model";
import { MessageLogEntry } from "./messageLogState";
import { SubmissionQuery, SubmissionResult } from "../model/Submission";

export interface SubmissionState {

    submissionDialogOpen: boolean;
    submissionFilesDialogOpen: boolean;
    submissionMetaDialogOpen: boolean;
    submissionFileIssueDialogOpen: boolean;
    deleteSubmissionFileAlertOpen: boolean;
    deleteSubmissionAlertOpen: boolean,
    uploadSubmissionFileDialogOpen: boolean,
    setSubmissionPublicationDateDialogOpen: boolean,

    selectedSubmission: Submission;
    selectedSubmissionFile: SubmissionFile;

    submissionId: string;
    dataFiles: File[];
    docFiles: File[];
    path: string;
    publicationDate: string | null;
    allowPublication: boolean;
    requestDOI: boolean;
    requester_email: string;
    doi: string;

    currentDatasetValidationResults: DatasetValidationResult[];
    currentSubmissionFiles: SubmissionFile[];
    currentSubmissionId: string;

    submissionQuery: SubmissionQuery;
    submissionResult: SubmissionResult;

    helpDialogOpen: boolean;

    submissionPublicationDate: string | null;

    submissionSucceeded: boolean;

    submissionMessages: MessageLogEntry[];
}

export function newSubmissionState() {
    return {
        submissionQuery: {loading: false, count: 10, offset: 0},
        submissionResult: {submissions: [], tot_count: 0},

        submissionDialogOpen: false,
        submissionFilesDialogOpen: false,
        submissionMetaDialogOpen: false,
        submissionFileIssueDialogOpen: false,
        deleteSubmissionFileAlertOpen: false,
        deleteSubmissionAlertOpen: false,
        uploadSubmissionFileDialogOpen: false,
        setSubmissionPublicationDateDialogOpen: false,

        submissionId: '',
        dataFiles: [],
        docFiles: [],
        path: '',
        publicationDate: null,
        allowPublication: false,

        currentDatasetValidationResults: [],
        currentSubmissionFiles: [],
        currentSubmissionId: '',

        selectedSubmission: {
            submission_id: '',
            user_id: 0,
            date: '',
            path: '',
            status: '',
            files: [],
            file_refs: [],
            publication_date: '',
            allow_publication: false,
            doi: '',
            requester_email: '',
        },

        selectedSubmissionFile: {
            index: 0,
            submission_id: '',
            filename: '',
            status: 'OK',
            filetype: 'DOCUMENT',
            creationdate: '',
            result: {
                status: 'OK',
                issues: [],
            }
        },

        helpDialogOpen: false,
        submissionPublicationDate: null,

        submissionSucceeded: false,
        submissionMessages: [],
        newEntries: [],
        oldEntries: [],

        requestDOI: false,
        requester_email: '',
        doi: ''
    }
}
